import { jsPDF } from "jspdf";

const GREEN = [16, 185, 129];
const DARK = [15, 23, 42];
const GRAY = [100, 116, 139];

const fmtEuro = (n) => `${(Number(n) || 0).toFixed(2).replace(".", ",")} €`;

let _logoCache;
async function loadLogo() {
  if (_logoCache !== undefined) return _logoCache;
  try {
    const res = await fetch("/logo192.png");
    const blob = await res.blob();
    _logoCache = await new Promise((resolve) => {
      const r = new FileReader();
      r.onloadend = () => resolve(r.result);
      r.onerror = () => resolve(null);
      r.readAsDataURL(blob);
    });
  } catch {
    _logoCache = null;
  }
  return _logoCache;
}

// Downloadable Premium billing receipt
export async function downloadReceiptPdf(h) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const M = 56;
  let y = 72;

  const logo = await loadLogo();
  const tx = logo ? M + 46 : M;
  if (logo) {
    try { doc.addImage(logo, "PNG", M, y - 30, 34, 34); } catch { /* ignore */ }
  }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.setTextColor(...GREEN);
  doc.text("PanierMoinsCher", tx, y);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(...GRAY);
  doc.text("Reçu de paiement", W - M, y, { align: "right" });

  y += 14;
  doc.setDrawColor(...GREEN);
  doc.setLineWidth(2);
  doc.line(M, y, W - M, y);

  y += 40;
  doc.setFontSize(10);
  doc.setTextColor(...GRAY);
  const date = h.date ? new Date(h.date).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }) : "—";
  if (h.session_id) { doc.text(`Référence : ${h.session_id}`, M, y); y += 16; }
  doc.text(`Date : ${date}`, M, y);

  y += 40;
  const rows = [
    ["Formule", h.plan || "Premium"],
    ["Date de paiement", date],
    ["Moyen de paiement", "Carte bancaire (Stripe)"],
  ];
  doc.setFontSize(11);
  rows.forEach(([k, v]) => {
    doc.setTextColor(...GRAY);
    doc.text(k, M, y);
    doc.setTextColor(...DARK);
    doc.text(String(v), W - M, y, { align: "right" });
    y += 24;
  });

  y += 8;
  doc.setDrawColor(230, 232, 236);
  doc.setLineWidth(1);
  doc.line(M, y, W - M, y);
  y += 30;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(...DARK);
  doc.text("Montant payé", M, y);
  doc.setFontSize(20);
  doc.setTextColor(...GREEN);
  doc.text(`${fmtEuro(h.amount)} TTC`, W - M, y, { align: "right" });

  y += 60;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...GRAY);
  doc.text("Merci de votre confiance · PanierMoinsCher · Pilote Île-de-France", M, y);

  const suffix = h.date ? new Date(h.date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
  doc.save(`recu-paniermoinscher-${suffix}.pdf`);
}

// Downloadable printable shopping list
export async function downloadShoppingListPdf(groups) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 56;
  let y = 72;

  const logo = await loadLogo();
  const tx = logo ? M + 46 : M;
  if (logo) {
    try { doc.addImage(logo, "PNG", M, y - 30, 34, 34); } catch { /* ignore */ }
  }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.setTextColor(...GREEN);
  doc.text("PanierMoinsCher", tx, y);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(...GRAY);
  doc.text("Liste de courses", W - M, y, { align: "right" });

  y += 14;
  doc.setDrawColor(...GREEN);
  doc.setLineWidth(2);
  doc.line(M, y, W - M, y);

  y += 20;
  doc.setFontSize(10);
  doc.setTextColor(...GRAY);
  doc.text(new Date().toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }), M, y);
  y += 24;

  groups.forEach((g) => {
    if (y > H - 100) { doc.addPage(); y = 72; }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(6, 78, 59);
    doc.text(g.title, M, y);
    y += 20;

    let total = 0;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    g.lines.forEach((l) => {
      if (y > H - 80) { doc.addPage(); y = 72; }
      total += l.line_total || 0;
      // checkbox
      doc.setDrawColor(...GREEN);
      doc.setLineWidth(1.2);
      doc.roundedRect(M, y - 9, 11, 11, 2, 2);
      doc.setTextColor(...DARK);
      doc.text(`${l.quantity}× ${l.name}`, M + 20, y);
      doc.setTextColor(...GRAY);
      doc.text(fmtEuro(l.line_total), W - M, y, { align: "right" });
      y += 22;
    });

    doc.setDrawColor(230, 232, 236);
    doc.setLineWidth(1);
    doc.line(M, y - 6, W - M, y - 6);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...DARK);
    doc.text("Total", M, y + 12);
    doc.setTextColor(...GREEN);
    doc.text(fmtEuro(total), W - M, y + 12, { align: "right" });
    y += 40;
  });

  doc.save("liste-courses-paniermoinscher.pdf");
}
